module.exports = __webpack_public_path__ + "img/TopCreativeLeaderOfTheYear.6dd2ce8c.jpg";